
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import FindDoctors from './Components/Pages/FindDoctors';

import Request from './Components/Pages/Request';

import Patient from './Components/Pages/Patient';
import ViewDoctors from './Components/Pages/ViewDoctors';

import Login from './Components/Pages/Login';
import Dashboard from './Components/Pages/Dashboard';
import FindHospitals from './Components/Pages/FindHospital';
import ViewHospitals from './Components/Pages/ViewHospitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      
      <Provider store={store}>
      <BrowserRouter>
       <Toaster position="top-right" richColors />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/find-doctors' element={<FindDoctors/>}/>
        <Route path='/find-hospitals' element={<FindHospitals/>}/>
        <Route path='/request' element={<Request/>}/>
        <Route path='/patients' element={<Patient/>}/>
         <Route path='/view-doctors' element={<ViewDoctors/>}/>
          <Route path='/view-hospitals' element={<ViewHospitals/>}/>
      </Routes>
      </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
